export enum FnnRouteName {
    Index = 'system.fnn.index',
    Create = 'system.fnn.create',
    Edit = 'system.fnn.edit',
}

export default {
    path: 'fnn',
    name: FnnRouteName.Index,
    component: () => import('@/views/system/fnn/Index.vue'),
    meta: {
        auth: true,
        label: 'FNN',
        icon: 'fal fa-phone-office fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-fnn',
    },
    children: [
        {
            path: 'create',
            name: FnnRouteName.Create,
            component: () => import('@/views/system/fnn/Index.vue'),
            meta: {
                auth: true,
                label: 'Add FNN',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-fnn',
            },
        },
        {
            path: ':fnnId/edit',
            name: FnnRouteName.Edit,
            component: () => import('@/views/system/fnn/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit FNN',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-fnn',
            },
        },
    ],
}
